// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Photos__row":"tg_a bhv_a bhv_r bhv_j","Photos__img":"tg_b bhv_b"};